var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.5C13.83 1.5 14.5 2.17 14.5 3V15C14.5 15.83 13.83 16.5 13 16.5H3C2.17 16.5 1.5 15.83 1.5 15V3C1.5 2.17 2.17 1.5 3 1.5H13ZM13 0H3C1.34 0 0 1.34 0 3V15C0 16.66 1.34 18 3 18H13C14.66 18 16 16.66 16 15V3C16 1.34 14.66 0 13 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.41992H4.75C4.33579 4.41992 4 4.75571 4 5.16992C4 5.58414 4.33579 5.91992 4.75 5.91992H11.25C11.6642 5.91992 12 5.58414 12 5.16992C12 4.75571 11.6642 4.41992 11.25 4.41992Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.41992H4.75C4.34 4.41992 4 4.75992 4 5.16992C4 5.57992 4.34 5.91992 4.75 5.91992H11.25C11.66 5.91992 12 5.57992 12 5.16992C12 4.75992 11.66 4.41992 11.25 4.41992Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.41992H4.75C4.33579 7.41992 4 7.75571 4 8.16992C4 8.58414 4.33579 8.91992 4.75 8.91992H11.25C11.6642 8.91992 12 8.58414 12 8.16992C12 7.75571 11.6642 7.41992 11.25 7.41992Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.41992H4.75C4.34 7.41992 4 7.75992 4 8.16992C4 8.57992 4.34 8.91992 4.75 8.91992H11.25C11.66 8.91992 12 8.57992 12 8.16992C12 7.75992 11.66 7.41992 11.25 7.41992Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.4199H4.75C4.33579 10.4199 4 10.7557 4 11.1699C4 11.5841 4.33579 11.9199 4.75 11.9199H8.25C8.66421 11.9199 9 11.5841 9 11.1699C9 10.7557 8.66421 10.4199 8.25 10.4199Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.4199H4.75C4.34 10.4199 4 10.7599 4 11.1699C4 11.5799 4.34 11.9199 4.75 11.9199H8.25C8.66 11.9199 9 11.5799 9 11.1699C9 10.7599 8.66 10.4199 8.25 10.4199Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.7b0528e0a70a0e6e0e197dd421fd1ac4.svg";
export { ForwardRef as ReactComponent };